import React from "react";
import { Col, Row } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../state-management/root-reducer";
import { clearLocationError } from "../../state-management/slices/global/global.slice";
import { clearLookupsError } from "../../state-management/slices/lookups/lookups.slice";
import { clearOutageError } from "../../state-management/slices/outages/outages.slice";

import AlertStyles from "./Alert.styles";
import { IAlertListProps } from "./Alert.types";
import GENERIC_ALERT from "./GenericAlert.component";

const ALERT_LIST: React.FC<IAlertListProps> = (props: IAlertListProps) => {
  const dispatch = useDispatch();
  const { outagesError } = useSelector((state: RootState) => state.outages);
  const { locationServicesError } = useSelector(
    (state: RootState) => state.globalState.locationServices
  );
  const { lookupCollectionError } = useSelector(
    (state: RootState) => state.lookups
  );

  return (
    <AlertStyles.AlertList className="alert-list" data-testid="alert-list">
      {locationServicesError && (
        <li>
          <GENERIC_ALERT
            message={locationServicesError?.displayMessage}
            variant="primary"
            onClose={(event: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
              dispatch(clearLocationError());
            }}
          />
        </li>
      )}
      {(lookupCollectionError || outagesError) && (
        <li>
          <GENERIC_ALERT
            message={
              lookupCollectionError
                ? lookupCollectionError.displayMessage
                : outagesError?.displayMessage
            }
            variant="danger"
            onClose={(event: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
              dispatch(clearOutageError());
              dispatch(clearLookupsError());
            }}
          />
        </li>
      )}
    </AlertStyles.AlertList>
  );
};

export default ALERT_LIST;
